import React from 'react';
import { Link } from 'react-router-dom';
import TFLogo from '../../assets/TF-sun-logo.png';
import './Header.css';

// Header component with logo and navigation
function Header() {
  return (
    <div className="brand-header">
      <div className="container">
        {/* Logo with home page link */}
        <div className="brand-container">
          <Link to="/">
            <img 
              src={TFLogo} 
              alt="TravelFind by Claiva - AI-powered deal validation and conversational agent" 
              className="brand-logo"
            />
          </Link>
        </div>
        {/* Navigation link to AI-lerts feature */}
        {/* <Link to="/alerts" className="ai-lerts-button">
          TRY OUR AI-LERTS
        </Link> */}
      </div>
    </div>
  );
}

export default Header;
